import { useEntity } from '@backstage/plugin-catalog-react';
import {
  EntityBlackDuckContent,
  isBlackDuckAvailable,
} from '@mercedes-benz/plugin-blackduck';
import { getColors, typography } from '@mercedes-benz/odp-theme-v2';
import { makeStyles } from 'tss-react/mui';
import SecurityIcon from '@mui/icons-material/Security';
import { PluginTabWrapper } from './PluginTabWrapper';

const useStyles = makeStyles()(theme => {
  const c = getColors(theme.palette.mode);
  const isLight = theme.palette.mode === 'light';
  const fgAlpha = (a: number) =>
    isLight ? `rgba(0, 0, 0, ${a})` : `rgba(255, 255, 255, ${a})`;
  return {
    emptyState: {
      padding: 48,
      minHeight: 400,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 12,
      textAlign: 'center',
    },
    iconWrapper: {
      width: 56,
      height: 56,
      borderRadius: '50%',
      background: 'rgba(0, 120, 214, 0.1)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& svg': {
        width: 28,
        height: 28,
        color: c.primary.main,
      },
    },
    title: {
      fontFamily: typography.fontFamilyCorpoSText,
      color: c.text.primary,
      fontWeight: 600,
      fontSize: '1.1rem',
      margin: 0,
      userSelect: 'none',
    },
    description: {
      fontFamily: typography.fontFamilyCorpoSText,
      color: fgAlpha(0.55),
      fontSize: '0.875rem',
      margin: 0,
      maxWidth: 420,
      lineHeight: 1.6,
    },
  };
});

export const BlackDuckTab = () => {
  const { classes } = useStyles();
  const { entity } = useEntity();

  if (!isBlackDuckAvailable(entity)) {
    return (
      <PluginTabWrapper>
        <div className={classes.emptyState}>
          <div className={classes.iconWrapper}>
            <SecurityIcon />
          </div>
          <h3 className={classes.title}>BlackDuck not configured</h3>
          <p className={classes.description}>
            Add the <code>synopsys.com/project-key</code> annotation to enable
            BlackDuck scanning.
          </p>
        </div>
      </PluginTabWrapper>
    );
  }

  return (
    <PluginTabWrapper>
      <EntityBlackDuckContent />
    </PluginTabWrapper>
  );
};
